import { IExpressionEvaluator } from "../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../Models/IExpressionEvaluatorContext";
import { ObjectExpression } from "../../Models/ObjectExpression";

export class ObjectExpressionEvaluator implements IExpressionEvaluator<ObjectExpression> {
  get type(): string {
    return "Object";
  }

  private buildObject(keys: string[], values: any[]): Record<string, any> {
    const result: Record<string, any> = {};
    for (let i = 0; i < keys.length; i++) {
      result[keys[i]] = values[i];
    }
    return result;
  }

  evaluate(expression: ObjectExpression, context: IExpressionEvaluatorContext): MaybePromise {
    const keys = Object.keys(expression.Properties);
    const results: any[] = [];
    let hasPromise = false;

    for (const key of keys) {
      const propExpression = expression.Properties[key];
      const value = context.Evaluator.evaluate(propExpression, context);
      results.push(value);
      if (value instanceof Promise) {
        hasPromise = true;
      }
    }

    // If any promise exists, wait for all and then build object
    if (hasPromise) {
      return Promise.all(results).then((values) => this.buildObject(keys, values));
    }

    // All sync, build object immediately
    return this.buildObject(keys, results);
  }
}



